var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/question-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1c5.8 0 10.45 4.65 10.55 10.5.05 5.65-4.6 10.4-10.25 10.55h-.25c-2.3 0-4.4-.75-6.15-2l-2.8 1.4c-.05.05-.15.05-.2.05-.3 0-.55-.3-.4-.6l1.35-2.8c-1.65-2.05-2.55-4.7-2.3-7.6.45-4.95 4.45-8.95 9.35-9.45.4-.05.75-.05 1.1-.05zm-.406 15.047c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm.7-11c-1.4-.2-2.65.25-3.6 1.05-.25.2-.25.55-.05.75.15.2.45.2.65.05.75-.65 1.8-1 2.9-.8 1.45.25 2.65 1.45 2.85 2.9.3 2-1.1 3.75-2.95 4-.15.05-.35.05-.5.05-.15 0-.35-.05-.5-.05v1.55c0 .3.2.5.5.5s.5-.2.5-.5v-.55c2.45-.25 4.3-2.5 3.95-5.1-.25-1.95-1.85-3.5-3.75-3.85z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e78e0db83ad954d0d5469a7bd340e94e.svg";
export { ForwardRef as ReactComponent };